import React, { PropTypes } from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { Button } from 'react-bootstrap';
import axios from '../../../../constants/axios.js';
import alert from 'alertify.js';
import FormRenderField from './../../../FormTemplate/InputControl';

class SalePrepaidReceive extends React.Component {
   constructor(props) {
      super(props);

      this.state = {
         billInfo: {},
      };
   }

   componentDidMount() {
      const { invoiceId } = this.props.params;
      axios.get(`inventorySales/billInformation/${invoiceId}`)
         .then((res) => {
            this.setState({
               billInfo: res.data
            });
         });
   }

   submit = (inputs) => {
      inputs.invoice_id = this.props.params.invoiceId;
      return axios.post('inventorySales/salePrepaidReceive', inputs)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Saved');
               this.context.router.push('/sale/saleInvoiceDetail/' + this.props.params.invoiceId);
            } else {
               alert.error('Something Unexpected');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            } else {
               alert.error('Ohh God. Sob Ses.');
            }
         });
   };

   render() {
      const { handleSubmit, submitting, invalid, error } = this.props;
      const { billInfo } = this.state;
      return (
         <div>
            <div>
               <p>Bill id: {billInfo.id}</p>
               <p>Contact Name: {billInfo.contact_name}</p>
               <p>Prepaid Amount: {billInfo.prepaidAmount}</p>
               <p>Bill Amount: {billInfo.amount}</p>
               <p>Bill Due: {billInfo.amount_due}</p>
            </div>


            <h4>Prepaid Amount Receive Form</h4>
            <form noValidate autoComplete="off" onSubmit={handleSubmit(this.submit)} >
               <Field name="amount" type="number" component={FormRenderField} label="Amount To Receive" />
               {error && <strong className="input-validation-error" >{error}</strong>}
               <Button type="submit" bsStyle="success" block
                       disabled={submitting || invalid} >Pay</Button>
            </form>
         </div>
      );
   }
}

SalePrepaidReceive.propTypes = {
   handleSubmit: PropTypes.func,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   error: PropTypes.object,
   params: PropTypes.object,
};

SalePrepaidReceive.contextTypes = {
   router: PropTypes.object
};

export default reduxForm({
   form: 'salePrepaidReceive',
})(SalePrepaidReceive);



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Sale/SalePrepaidReceive/SalePrepaidReceive.js
 **/